module.exports = __webpack_public_path__ + "img/changeDBL.e1e9ebd0.svg";